var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"disabled":!_vm.addonsAppUrl || !_setup.isSecureContext,"block":"","text":"","color":"primary"},on:{"click":_setup.copyAddonsAppUrl}},[_vm._v(" Kopiera tillvalslänk "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("mdi-content-copy")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }